import { blogTypes } from '../actions'
import { ofType, ActionsObservable } from 'redux-observable'
import { ajax } from 'rxjs/ajax'
import { switchMap, map, catchError } from 'rxjs/operators'
import { apiUrl } from '../config/settings'

// Helper function for paginated blog requests to avoid code duplication
const createPaginatedBlogRequest = (url, successType, failType) => {
  return ajax({
    url,
    method: 'GET',
    headers: ''
  }).pipe(
    map(({ response }) => {
      if (response.success) {
        const payload = response.payload
        return ({ type: successType, payload })
      }
    }),
    catchError(err => {
      return ActionsObservable.create(obs => {
        obs.next({ type: failType, payload: {} })
        obs.complete()
      })
    })
  )
}

export const getBlog = action$ =>
  action$.pipe(
    ofType(blogTypes.GET_BLOG),
    switchMap(({ payload }) => {
      return ajax({
        url: `${apiUrl}/blog`,
        method: 'GET',
        headers: ''
      })
    .pipe(
      map(({ response }) => {
        if (response.success) {
          const payload = response.payload
          return ({ type: blogTypes.GET_BLOG_SUCCESS, payload })
        }
      }),
      catchError(err => {
        return ActionsObservable.create(obs => {
          obs.next({ type: blogTypes.GET_BLOG_FAIL, payload: {} })
          obs.complete()
        })
      })
    )
  })
)

export const getBlogPage = action$ =>
  action$.pipe(
    ofType(blogTypes.GET_BLOG_PAGE),
    switchMap(({ payload }) => {
      return ajax({
        url: `${apiUrl}/blog/${payload.page}`,
        method: 'GET',
        headers: ''
      })
    .pipe(
      map(({ response }) => {
        if (response.success) {
          const payload = response.payload
          return ({ type: blogTypes.GET_BLOG_PAGE_SUCCESS, payload })
        }
      }),
      catchError(err => {
        return ActionsObservable.create(obs => {
          obs.next({ type: blogTypes.GET_BLOG_PAGE_FAIL, payload: {} })
          obs.complete()
        })
      })
    )
  })
)

// Consolidated logic for both getBlogNextPage and getBlogPageWithSize
// since they use identical endpoints
export const getBlogNextPage = action$ =>
  action$.pipe(
    ofType(blogTypes.GET_BLOG_NEXT_PAGE),
    switchMap(({ payload }) => {
      return createPaginatedBlogRequest(
        `${apiUrl}/blog/${payload.page}/${payload.size}`,
        blogTypes.GET_BLOG_NEXT_PAGE_SUCCESS,
        blogTypes.GET_BLOG_NEXT_PAGE_FAIL
      )
    })
  )

export const getBlogPageWithSize = action$ =>
  action$.pipe(
    ofType(blogTypes.GET_BLOG_PAGE_WITH_SIZE),
    switchMap(({ payload }) => {
      return createPaginatedBlogRequest(
        `${apiUrl}/blog/${payload.page}/${payload.size}`,
        blogTypes.GET_BLOG_PAGE_WITH_SIZE_SUCCESS,
        blogTypes.GET_BLOG_PAGE_WITH_SIZE_FAIL
      )
    })
  )

export const getPost = action$ =>
  action$.pipe(
    ofType(blogTypes.GET_POST),
    switchMap(({ payload }) => {
      return ajax({
        url: `${apiUrl}/blog/post/${payload}`,
        method: 'GET',
        headers: ''
      })
    .pipe(
      map(({ response }) => {
        if (response.success) {
          const payload = response.payload
          return ({ type: blogTypes.GET_POST_SUCCESS, payload })
        }
      }),
      catchError(err => {
        return ActionsObservable.create(obs => {
          obs.next({ type: blogTypes.GET_POST_FAIL, payload: {} })
          obs.complete()
        })
      })
    )
  })
)
